import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../host";
import { GET_INQUIRES_PAGE, GET_INQUIRIES } from "./Inquiry";

function useInquiry() {
  const dispatch = useDispatch();
  const { inquiry, totalLength, pageNumber } = useSelector(
    state => state.inquiry
  );
  const fetchBypageNumber = async pageNumber => {
    try {
      const res = await axios.post(BASE_URL + "inquiry", {
        page_number: pageNumber
      });
      dispatch({
        type: GET_INQUIRES_PAGE,
        inquiry: res.data.data,
        pageNumber: pageNumber
      });
    } catch (error) {}
  };
  const fetchAllInquiry = async () => {
    try {
      const res = await axios.get(BASE_URL + "inquiry");
      console.log(res.data.data);
      dispatch({
        type: GET_INQUIRIES,
        inquiry: res.data.data,
        total_record: res.data.total_record
      });
    } catch (error) {
      console.log(error);
    }
  };
  return {
    inquiry,
    totalLength,
    pageNumber,
    fetchBypageNumber,
    fetchAllInquiry
  };
}

export default useInquiry;
